import { render } from "./CompetitionJudges.vue?vue&type=template&id=8ebaae06&scoped=true"
import script from "./CompetitionJudges.vue?vue&type=script&lang=js"
export * from "./CompetitionJudges.vue?vue&type=script&lang=js"

import "./CompetitionJudges.vue?vue&type=style&index=0&id=8ebaae06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebaae06"]])

export default __exports__